import React from 'react';
import { MessageSquare, ArrowRight } from 'lucide-react';

interface ResultsCTAProps {
  onContact: () => void;
}

export function ResultsCTA({ onContact }: ResultsCTAProps) {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl shadow-lg overflow-hidden">
      <div className="px-8 py-12">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Ready to Optimize Your HOA's Investment Strategy?
          </h2>
          <p className="text-blue-100 text-lg mb-8">
            Our investment specialists are here to help you implement the right strategy for your HOA's needs.
            Schedule a consultation to discuss your options in detail.
          </p>
          <button
            onClick={onContact}
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-colors duration-200 shadow-lg"
          >
            <MessageSquare className="h-5 w-5" />
            Schedule a Consultation
            <ArrowRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}